<template>
    <div class="label-frame margin-tb-20">
        <label>
            <span class="red-color" v-show="showStar">*&nbsp;&nbsp;</span>
            <base-text :inline="true" :only-text="false">{{ label }}:</base-text>
        </label>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BLabelFrame',
    props: {
        label: {
            type: String,
            required: true
        },
        showStar: {
            type: Boolean
        }
    }
}
</script>

<style lang="less" scoped>
    .label-frame {
        display: flex;
    }
    label {
        width: 20%;
        display: inline-block;
    }
</style>
